/**
 * @file schemas/m1-payments.ts
 * @description 案件費用繳款 Zod 校驗 schema（前後端共用，M1）。
 *
 * 命名加 m1- 前綴以避免與 P0 payment-status 混淆。
 */
import { z } from 'zod';
/**
 * 繳費類型枚舉。
 *
 * - initial：首期款（案件在「已報價」登記時自動推進「已報價→已收費」）
 * - full：全款（一次繳清；業務效果等同首期款，同樣觸發「已報價→已收費」自動推進）
 * - balance：尾款（僅記錄，不動案件狀態）
 * - supplementary：補繳（僅記錄，不動案件狀態）
 */
export const PAYMENT_TYPES = ['initial', 'full', 'balance', 'supplementary'];
/**
 * 建立繳款記錄請求 schema。
 * paymentCode 由後端自動生成。
 */
export const createM1PaymentSchema = z.object({
    /** 繳款金額（新台幣分） */
    amount: z.number().int().positive(),
    /** 繳費類型：initial / full / balance / supplementary */
    paymentType: z.enum(PAYMENT_TYPES).default('initial'),
    /** 繳費方式（ATM/電匯/票據/現金） */
    paymentMethod: z.string().max(50).optional(),
    /** 繳費憑證文件 ID（上傳後填入） */
    proofFileId: z.number().int().positive().optional(),
    /** 繳款日期（ISO 8601） */
    paidAt: z.string().datetime({ offset: true }).optional(),
    /** 備注 */
    notes: z.string().max(2000).optional(),
});
/**
 * 確認繳款請求 schema（主管確認後驅動案件轉換至「已繳費」）。
 */
export const confirmM1PaymentSchema = z.object({
    /** 確認備注 */
    notes: z.string().max(500).optional(),
});
/**
 * 編輯繳款記錄請求 schema（admin 糾錯用）。
 *
 * 全字段可選（partial），僅就地更新傳入字段；
 * 不影響案件 workflowState / confirmedAt（即不重新觸發首期款推進）。
 */
export const updateM1PaymentSchema = createM1PaymentSchema.partial();
